// 3rd party
import * as React from 'react';

// Components
import { WidgetCodeMarkupForm } from 'components/shared/widget';

interface ExpediaPackageWidgetCodeMarkupProps {
  demoLink: string;
  demoCodeMarkupWidgetStyles: string;
}

const ExpediaPackageWidgetCodeMarkup = React.memo(
  // tslint:disable-next-line:no-shadowed-variable
  function ExpediaPackageWidgetCodeMarkup(props: ExpediaPackageWidgetCodeMarkupProps): JSX.Element {
    const { demoLink, demoCodeMarkupWidgetStyles, ...otherProps } = props;

    const codeMarkup =
      `<div id="packageDealsWidget" style="${demoCodeMarkupWidgetStyles}">\n` +
      `\t<iframe id="widgetIframe" src="${demoLink}" width="100%" height="100%" frameborder="0" scrolling="no"></iframe>\n` +
      '</div>';

    return <WidgetCodeMarkupForm {...otherProps} codeMarkup={codeMarkup} />;
  },
);

export { ExpediaPackageWidgetCodeMarkup };
